import { render, staticRenderFns } from "./PlayerFormDialog.vue?vue&type=template&id=013e048a"
import script from "./PlayerFormDialog.vue?vue&type=script&lang=js"
export * from "./PlayerFormDialog.vue?vue&type=script&lang=js"
import style0 from "./PlayerFormDialog.vue?vue&type=style&index=0&id=013e048a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports